import { ObjectByString, getValue } from "@/shared/utils/helpers";
import { useMemo } from "react";
import { BaseRow, TableHookProps } from "./types";

const useTableHook = ({ columns, data, onRowsStyling }: TableHookProps) => {
  const rows = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) return [];
    const res = data?.map((row, key) => {
      let style = {};
      let currentRow: BaseRow = {
        _group: row?._group ?? false,
        _original: row,
        styles: {},
      };

      if (row._group === true) {
        currentRow = {
          ...currentRow,
          ...row._rows,
          _id: row._id,
          styles: row?._styles ?? {},
        };
      }

      columns
        .filter((column) => !column.disable)
        .forEach((column, index) => {
          if (row?._group === true) {
            return "";
          }
          let addedStyle = column?.rowStyle ? column?.rowStyle(row, index) : {};
          style = { ...style, ...addedStyle };
          currentRow["styles"] = style;
          currentRow[column.id] = column?.Cell
            ? column.Cell(row, key)
            : column.accessor === "*"
              ? row
              : getValue(ObjectByString(row, `${column.accessor}`, null)) === null
                ? ""
                : getValue(ObjectByString(row, `${column.accessor}`, null));
        });
      return currentRow;
    });
    return res;
  }, [data, columns]);

  return { rows };
};

export default useTableHook;
